module.exports = __webpack_public_path__ + "img/med2.2ad1248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/med2.png
// module id = vHTs
// module chunks = 0